<template>
  <button
    class="btn-primary text-white font-bold text-base"
    :class="{
      '!bg-[#3176FF14] !text-primary !font-normal hover:opacity-60': variant === 'light',
    }"
    :type="type"
    :disabled="disabled"
  >
    <slot />
  </button>
</template>

<script setup lang="ts">
  withDefaults(
    defineProps<{
      type?: "button" | "submit" | "reset";
      disabled?: boolean;
      variant?: "default" | "light";
    }>(),
    {
      type: "button",
      disabled: false,
      variant: "default",
    }
  );
</script>

<style scoped></style>
